var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStoreLocationGraphic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.115 14.103c0 5.64-4.615 10.256-10.256 10.256S1.603 19.744 1.603 14.103 6.218 3.846 11.859 3.846s10.256 4.616 10.256 10.257z",
    fill: "#90CAF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.859 25c-3.205 0-5.77-4.808-5.77-10.897 0-6.09 2.565-10.898 5.77-10.898 3.205 0 5.77 4.808 5.77 10.898S15.063 25 11.858 25zm0-20.513c-2.436 0-4.487 4.423-4.487 9.616 0 5.192 2.051 9.615 4.487 9.615s4.487-4.423 4.487-9.615c0-5.193-2.051-9.616-4.487-9.616z",
    fill: "#1E88E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.385 9.615H3.333c-.384 0-.64-.256-.64-.64 0-.385.256-.642.64-.642H20.45c.384 0 .64.257.64.641 0 .385-.32.641-.704.641zM20.385 19.872H3.333c-.384 0-.64-.257-.64-.641 0-.385.256-.641.64-.641H20.45c.384 0 .64.256.64.64 0 .385-.32.642-.704.642zM1.603 13.462h20.513v1.282H1.603z",
    fill: "#1E88E5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E88E5",
    d: "M11.218 3.846H12.5v20.513h-1.282z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.346 10.32c-.961 1.475-1.795 2.629-1.795 2.629S15.064 7.05 15.064 4.55v-.128c-.833-.256-1.667-.449-2.564-.513 0 .193-.064.449-.064.641 0 3.013 3.526 7.949 5 9.936l2.051 2.692 2.051-2.692c.129-.192.321-.449.513-.705a8.787 8.787 0 00-.705-3.461z",
    fill: "#1E88E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.551 6.41c-.961 0-1.73-.64-1.923-1.474a10.53 10.53 0 00-5.769-1.73A10.888 10.888 0 00.962 14.102 10.888 10.888 0 0011.859 25a10.888 10.888 0 0010.897-10.897c0-3.013-1.218-5.706-3.205-7.693zM11.86 23.718a9.603 9.603 0 01-9.615-9.615 9.603 9.603 0 019.615-9.616 9.603 9.603 0 019.615 9.616 9.603 9.603 0 01-9.615 9.615z",
    fill: "#1E88E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.551.064a4.46 4.46 0 00-4.487 4.487c0 2.5 4.487 8.334 4.487 8.334s4.487-5.834 4.487-8.334A4.46 4.46 0 0019.551.064zm0 6.346a1.889 1.889 0 01-1.923-1.923c0-1.09.834-1.923 1.923-1.923 1.09 0 1.923.833 1.923 1.923s-.833 1.923-1.923 1.923z",
    fill: "#FF5C40"
  }))));
}

export default SvgStoreLocationGraphic;